





















import { Vue, Component, Prop } from "vue-property-decorator";
import { TemplateInput } from "@/store/template/types";

@Component
export default class DependencyInput extends Vue {
  store = this.$store.direct;

  @Prop() input!: TemplateInput;

  form = {
    variable: "",
    value: ""
  };

  get valid() {
    return (
      this.form.variable &&
      this.form.variable.length > 0 &&
      this.form.value &&
      this.form.value.length > 0
    );
  }

  get selected() {
    let sel = this.input.depends_on.map(dep => {
      return dep.variable;
    });
    sel.push(this.input.name);
    return sel;
  }

  get variables() {
    return this.store.state.template.selected.sections
      .map(section => {
        return section.inputs.map(input => {
          return input.name;
        });
      })
      .flat()
      .filter(dep => {
        return !this.selected.includes(dep);
      });
  }

  save() {
    this.input.depends_on.push(this.form);
    this.form = {
      variable: "",
      value: ""
    };
  }
}
